import PosCovid19 from '../pages/PosCovid19/Index'
import PosCovid19PorEquipeAcs from '../pages/PosCovid19/PorEquipeAcs'
import PosCovid19PorAcs from '../pages/PosCovid19/PorAcs'

export default [
  {
    path: '/pos-covid-19',
    component: () => import('@/pages/PosCovid19/Template.vue'),
    children: [
      {
        path: '/pos-covid-19',
        component: PosCovid19,
      },
      {
        path: '/pos-covid-19/equipe/acs',
        component: PosCovid19PorEquipeAcs,
      },
      {
        path: '/pos-covid-19/acs',
        component: PosCovid19PorAcs,
      },
    ],
  },
]
